import { createAction } from 'redux-actions'

import * as constants from './constants'

export const regenerateCode = createAction(constants.REGENERATE_CODE)
export const regenerateCodeSuccess = createAction(constants.REGENERATE_CODE_SUCCESS)
export const regenerateCodePending = createAction(constants.REGENERATE_CODE_PENDING)
export const regenerateCodeFailed = createAction(constants.REGENERATE_CODE_FAILED)



// WEBPACK FOOTER //
// ./src/modules/auth/actions.js